module.exports = __webpack_public_path__ + "static/fonts/TerpelSans-Black.703a4c9.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/TerpelSans/TerpelSans-Black.otf
// module id = R6aB
// module chunks = 6